import React, { Suspense, useMemo,useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';

import CommonUtil from "utils/CommonUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import use from "../../../../common/hooks/use";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	let totalCnt:number = 0;

	const [emailInfo, setCEmailInfo] = useState({});
    const [emailId, setEmailId] = useState("");
	const [emailSj,setEmailSj] = useState('');   //메일제목 
	const [emailCn,setEmailCn] = useState('');   //메일내용
	const [senderEmailAdres,setSenderEmailAdres] = useState('');   //수신자 메일주소
	const [senderNm,setSenderNm] = useState('');   //발신자 메일주소
	const [rcverEmailAdres,setRcverEmailAdres] = useState('');   //수신자 메일주소
	const [rcverNm,setRcverNm] = useState('');   //수신자 메일주소
	const [recptnTy,setRecptnTy] = useState('');   //수신유형 
	
	var ib = ib||{};
	ib = {
	//시트 초기화 구문
	'init':{
		"Cfg": {
			"SearchMode": 1,
			"AutoRowHeight": 1,
			"InfoRowConfig": "0",
			"Alternate":"0"
			
		},
		//틀고정 좌측 컬럼 설정
		"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
		"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": "수신유형(*)","Type": "Text","Name": "RECPTN_TY","Width": "100","Align": "Center","CanEdit": 0 },
			{"Header": "수신자 메일주소(*)","Type": "Text","Name": "RCVER_EMAIL_ADRES","MinWidth": 60,"Align": "Left","CanEdit": 0,"RelWidth": 3},
			{"Header": "수신자 이름(*)","Type": "Text","Name": "RCVER_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1}
		]
	
	},
	//시트 이벤트
	'event':{
	
		onRenderFirstFinish:function (evtParam) {
			var sheet = evtParam.sheet;
			//@ts-ignore	
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		}
		
	},
	//시트객체 생성
	'create':function () {
		let options = this.init;
	
		//@ts-ignore
		options.Events = this.event;
		//@ts-ignore
		IBSheet.create({
			id: 'sheet', // 생성할 시트의 id
			el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
			options: options, // 생성될 시트의 속성
			data: this.data // 생성될 시트의 정적데이터
		});
		// global 변수 선언
		//@ts-ignore
		window.currentPage = -1;
	},
	//조회 데이터
	'data':[]
	}

	const contentObj = useMemo(() => CommonUtil.execute({
        url: 'adm_6110_detail',
        data: {
          "EMAIL_ID": emailId
        }
    }).then((result: any) => {
        return {
            cont: result.LIST[0].EMAIL_CN
        }
    }), [emailId]);



	// 상세 데이터 가져오기
	async function initCall(paramMainId){
		let param = {
			"EMAIL_ID": paramMainId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6110_detail',
			data: param,
			progressBar:true
		})

		const result = response.LIST;

		//데이터 바인딩
		setCEmailInfo(result[0]);
		setEmailId(result[0].EMAIL_ID);
		setEmailSj(result[0].EMAIL_SJ)
		setEmailCn(result[0].EMAIL_CN);
		setSenderEmailAdres(result[0].SENDER_EMAIL_ADRES);
		setSenderNm(result[0].SENDER_NM);
	
		
		//전체ROW개수 
		totalCnt = Object.keys(result).length;
		setTotalRowCnt(Object.keys(result).length);
			
		//데이터 처리
		ib.data = result;
		// @ts-ignore	
		sheet.loadSearchData(result);  //data 로딩 처리 

		// @ts-ignore	
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		
	};

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(emailInfo).length != 0){
			return emailInfo[name];
		}else{
			return '';
		}
	};

	//목록으로 
	const goList = () =>{
		history.push({
			pathname: './adm6100',  
			state: { data: receivedData }
		});
	}

	//상세페이지 로딩시 해야할 것
	//비밀번호 오류횟수 , 권한등록 ,사업지정 , 출엽기업 승인, 이메일 인증발송
	React.useEffect(() => {
		
		//ib시트 생성
		ib.create();
		
		if(receivedData != undefined){
			let emailId = receivedData.vEMAIL_ID;
			setEmailId(emailId)
			localStorage.setItem("emailId", emailId);
		}
		
		let emailIdStorage = localStorage.getItem("emailId");
		if (emailIdStorage != null) {
			setEmailId(emailIdStorage);
		}
		
		//상세데이터 가지고 오기
		initCall(emailIdStorage);

        return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);		 
        }
		
    },[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">메일발송관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">메일 발송 상세</h1>
						<form className="fo fo-col2 mb30" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">메일제목</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailSj} valueChanged={(value) => setEmailSj(value)}  placeholder={'메일제목'} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">발송자 메일 주소</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={senderEmailAdres} valueChanged={(value) => setSenderEmailAdres(value)}  placeholder={'발송자 메일 주소'} readOnly={true}/>
									</div>						
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">발송자 이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={senderNm} valueChanged={(value) => setSenderNm(value)}  placeholder={'발송자 이름'} readOnly={true}/>
									</div>						
								</div>		
							</div> 
						</form>					
						
						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
						</div>
						<div id='sheetDiv' className='h100p'>[D] IBSHEET 영역</div>
						
						<div>
							{/* <UISunEditor value={getInfo("EMAIL_CN")} displayOnly /> */}
							<Suspense fallback={<PageLoading/>}>
								<ViewLazyContent contentObj={contentObj}/>
							</Suspense>
						</div>
						
						<div className="hz-root hz-right mt10">
							<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
						</div>					
							
						</main>

					</div>
		</PageContainer>
	);
}
export default ContentsContainer;


function ViewLazyContent({contentObj}: { contentObj: Promise<any> }) {
    const conntent = use(contentObj);
    return (
        <>
		<div className="fund-biz-preview">
			<UISunEditor value={conntent.cont} displayOnly/>
		</div>
            
        </>
    )
}